module.exports = __webpack_public_path__ + "img/icon_mine_coupon.b8599999.gif";